import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { IntercomProvider } from 'react-use-intercom'
import { ApolloProvider } from '@apollo/client'
import { getApiUrl } from 'utils/api/apiHelpers'
import { BreakpointProvider } from 'utils/context/BreakpointContext'
import { ChatWidgetProvider } from 'utils/context/ChatWidgetContext'
import { fmsGraphQLClient } from 'utils/graphql/client'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { RogersRestfulProvider } from 'components/RogersRestfulProvider'
import { App } from './components/App'
import { UserProvider } from './context/UserContext'
import { useFMSAnalytics } from './hooks'
import { configureStore } from './utils/configureStore'

const store = configureStore()

function FleetPlanner() {
  const { logout, userDetails } = useUserDetails()
  const { identifyUser } = useFMSAnalytics()

  useEffect(() => {
    identifyUser(userDetails)
  }, [identifyUser, userDetails])

  return (
    <Provider store={store}>
      <IntercomProvider appId={__INTERCOM_APP_ID__}>
        <ChatWidgetProvider chatId={__FRONT_CHAT_CHANNEL_ID__}>
          <UserProvider>
            <BreakpointProvider>
              <ApolloProvider client={fmsGraphQLClient}>
                <RogersRestfulProvider
                  onUnauthenticatedResponse={() => logout({ origin: 'fms' })}
                  baseApi={`${getApiUrl('FMS')}/v1`}>
                  <App />
                </RogersRestfulProvider>
              </ApolloProvider>
            </BreakpointProvider>
          </UserProvider>
        </ChatWidgetProvider>
      </IntercomProvider>
    </Provider>
  )
}

export default FleetPlanner
